import { Locale } from '../../lang/index';
import { localStorageUtil } from '../../utils/local-storage.util';

export const localeStorage = localStorageUtil<Locale>('chosenLocale');
